import { LinkOutlined, LoadingOutlined } from '@ant-design/icons';
import { Button, Descriptions, Divider, Space, Spin, Tag } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import myinvoisTransService from '../../../services/myinvois/myinvois_trans.service';
import moment from 'moment';
import { Link } from 'react-router-dom';
import JsonView from '@uiw/react-json-view';
import { nordTheme } from '@uiw/react-json-view/nord';
import numberHelper from '../../../helpers/functions/number.helper';

const MyInvoisDetailLayout = ({ document_id, }) => {
    const [state, setState] = useState({
        loading : false,
        document : null,
        park : null,
        validation_link : null,
    })

    const request_json = useMemo(() => {
        try {
            return JSON.parse(state?.document?.request);
        } catch (e) {
            return null; // or handle the error as needed
        }
    }, [state?.document?.request])
    
    const response_json = useMemo(() => {
        try {
            return JSON.parse(state?.document?.response);
        } catch (e) {
            return null; // or handle the error as needed
        }
    }, [state?.document?.response])

    const fetchDocumentDetail = async () => {
        setState(state => ({...state, loading : true, }));

        const myInvoisDetailResponse = await myinvoisTransService?.fetchSubmittedDocument(document_id);
        const { park, validation_link, document, } = myInvoisDetailResponse;
        setState(state => ({...state, loading : false, park, validation_link, document, }));
    }

    useEffect(() => {
        fetchDocumentDetail();
    }, [document_id])

    return (
        <>
            <div className='mobile-padding-12'>
                <Spin spinning={state?.loading} indicator={<LoadingOutlined />}>
                    <Space direction='vertical' style={{ width : '100%', }}>
                        <div style={{ display: 'flex', alignItems: 'end' }}>
                            <div style={{ textAlign: 'left' }}>
                                <div>
                                    <div>
                                        <span style={{ fontSize: 18, color: '#595959' }}>{state?.document?.myinvois_document_id ?? "Missing Document Id"}</span>
                                    </div>
                                    {/* <div>
                                        <span style={{ color: 'var(--secondary-text-color)', }}>{state?.document?.myinvois_submission_id ?? "Missing Submission Id"}</span>
                                    </div> */}
                                </div>

                                <div style={{marginTop:8,}}>
                                    <Space>
                                        <div>
                                            <Tag color={state?.document?.status === 'Valid' ? 'green' : 'red'} style={{ border: 'none' }}>
                                                <span>{`Status : ${state?.document?.status}`}</span>
                                            </Tag>
                                        </div>
                                        <div>
                                            <Tag color={'blue'} style={{ border: 'none' }}>
                                                <span>{`Email Sent : ${state?.document?.email_id ? state?.document?.receiver_email : "No"}`}</span>
                                            </Tag>
                                        </div>
                                    </Space>
                                </div>
                            </div>

                            <div style={{ marginLeft : 'auto', }}>
                                <a href={state?.validation_link} target='_blank'>
                                    <Button icon={<LinkOutlined />}>
                                        Validation Link
                                    </Button>
                                </a>
                            </div>
                        </div>

                        <div style={{ marginTop : 24, }}>
                            <div style={{textAlign:'left'}}>
                                <span style={{fontWeight:500, fontSize:16,}}>Detail</span>
                            </div>
                            <Divider style={{marginTop:12}}/>
                            <Descriptions
                            column={1}
                            bordered
                            size='small'
                            items={[{
                                key : 'ticket',
                                label : 'Transaction',
                                children : (
                                    <>
                                        {
                                            state?.document?.document_lines?.map((document_line, index) => {
                                                return (
                                                    <>
                                                        <Link to={`/ticket/detail/${document_line?.ticket?.ticket_id}`}>
                                                            <Tag>
                                                                <span>{`${document_line?.ticket?.unique_no}${document_line?.ticket?.salt}`}</span>
                                                            </Tag>
                                                        </Link>
                                                    </>
                                                )
                                            })
                                        }
                                    </>
                                )
                            },
                            ...(state?.document?.status === 'Valid' ? ([{
                                key: '1',
                                label: 'Receiver Name',
                                children: (
                                    <span>{state?.document?.receiver_name}</span>
                                ),
                            },{
                                key: '2',
                                label: 'Receiver TIN',
                                children: (
                                    <span>{state?.document?.receiver_id}</span>
                                ),
                            },{
                                key: '3',
                                label: 'Document ID',
                                children: (
                                    <span>{state?.document?.myinvois_document_id}</span>
                                ),
                            },{
                                key: '4',
                                label: 'Issue Date Time',
                                children: (
                                    <span>{moment(state?.document?.issue_date)?.format("YYYY-MM-DD hh:mm:ssa")}</span>
                                ),
                            },{
                                key: '5',
                                label: 'Received Date Time',
                                children: (
                                    <span>{moment(state?.document?.receive_date)?.format("YYYY-MM-DD hh:mm:ssa")}</span>
                                ),
                            },{
                                key: '6',
                                label: 'Validated Date Time',
                                children: (
                                    <span>{moment(state?.document?.validate_date)?.format("YYYY-MM-DD hh:mm:ssa")}</span>
                                ),
                            },{
                                key: '7',
                                label: 'Total Payable Amount',
                                children: (
                                    <span>{`${state?.park?.currency?.code}${numberHelper?.commaNumber(parseFloat(state?.document?.amount) ?? 0)}`}</span>
                                ),
                            },{
                                key: '8',
                                label: 'Status',
                                children: (
                                    <span>{state?.document?.status}</span>
                                ),
                            }]) : [])
                            ]}
                            />
                        </div>
                        
                        {
                            request_json && (
                                <>
                                    <div style={{ marginTop : 24, }}>
                                        <div style={{textAlign:'left'}}>
                                            <span style={{fontWeight:500, fontSize:16,}}>Request</span>
                                        </div>
                                        <Divider style={{marginTop:12}}/>
                                        <JsonView
                                        collapsed={1}
                                        style={{ textAlign : 'start', ...nordTheme, }}
                                        value={request_json}
                                        />
                                    </div>
                                </>
                            )
                        }

                        {
                            response_json && (
                                <>
                                    <div style={{ marginTop : 24, }}>
                                        <div style={{textAlign:'left'}}>
                                            <span style={{fontWeight:500, fontSize:16,}}>Response</span>
                                        </div>
                                        <Divider style={{marginTop:12}}/>
                                        <JsonView
                                        collapsed={1}
                                        style={{ textAlign : 'start', ...nordTheme, }}
                                        value={response_json}
                                        />
                                    </div>
                                </>
                            )
                        }
                        
                    </Space>
                </Spin>
            </div>
        </>
    );
}

export default MyInvoisDetailLayout;